import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { AuthProvider } from '@org/ui';
import { ensureCommunityI18n } from './i18n';

// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Import styles
import './styles.css';

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Render the app
const rootElement = document.getElementById('root')!;

const renderApp = () => {
  if (rootElement.innerHTML) {
    return;
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </StrictMode>,
  );
};

ensureCommunityI18n()
  .then(renderApp)
  .catch((error) => {
    console.error('Failed to initialize translations', error);
    renderApp();
  });
